import { CURBSIDE_PICKUP_REQUIRED, DEBUG } from 'config/constant';
import {
  ADD_CUSTOMER_ADDRESS,
  ADD_CUSTOMER_ADDRESS_SUCCESS,
  ADD_CUSTOMER_ADDRESS_FAILURE,
  FETCH_CUSTOMER_ADDRESS_LIST,
  FETCH_CUSTOMER_ADDRESS_LIST_SUCCESS,
  FETCH_CUSTOMER_ADDRESS_LIST_FAILURE,
  SELECT_CHECKOUT_STORE_TYPE,
  SELECT_CHECKOUT_PAYMENT_METHOD,
  FETCH_STORE_TIME_SLOTS,
  FETCH_STORE_TIME_SLOTS_SUCCESS,
  FETCH_STORE_TIME_SLOTS_FAILURE,
  FETCH_CART_AMOUNT_DETAILS,
  FETCH_CART_AMOUNT_DETAILS_SUCCESS,
  FETCH_CART_AMOUNT_DETAILS_FAILURE,
  SELECT_CHECKOUT_TIME_SLOT,
  SELECT_CUSTOMER_ADDRESS,
  SAVE_PLACE_ORDER,
  SAVE_PLACE_ORDER_SUCCESS,
  SAVE_PLACE_ORDER_FAILURE,
  CHECKOUT_SPECIAL_INSTRUCTION,
  CHECKOUT_ORDER_PERFERRED_CONTACT_TYPE,
  CHECKOUT_ORDER_PERFERRED_CONTACT,

  REMOVE_CUSTOMER_ADDRESS,
  REMOVE_CUSTOMER_ADDRESS_FAILURE,
  REMOVE_CUSTOMER_ADDRESS_SUCCESS,
  SELECT_PICKUP_TYPE,

  SAVE_PLACE_ORDER_CATERING_MEAL,
  SAVE_PLACE_ORDER_CATERING_MEAL_SUCCESS,
  SAVE_PLACE_ORDER_CATERING_MEAL_FAILURE,
  SAVE_EBT_PAYMENT_RESPONSE,
  SAVE_EBT_PAYMENT_PAID_LIST,

  CANCEL_EBT_PAYMENT,
  CANCEL_EBT_PAYMENT_SUCCESS,
  CANCEL_EBT_PAYMENT_FAILURE,

  RESET_EBT_CHECKOUT_STATE,
  FETCH_ORDER_DETAIL,
  FETCH_ORDER_DETAIL_SUCCESS,
  FETCH_ORDER_DETAIL_FAILURE,
  SAVE_PAYMENT_TRANSACTION_ID,
  SAVE_PAYMENT_TRANSACTION_TYPE,
  EXTERNAL_DELIVERY_ID,

  FETCH_CATERING_AND_MEALKIT_CART_AMOUNT_DETAILS,
  FETCH_CATERING_AND_MEALKIT_CART_AMOUNT_DETAILS_SUCCESS,
  FETCH_CATERING_AND_MEALKIT_CART_AMOUNT_DETAILS_FAILURE,

  CHECKOUT_ORDER_DOORDASH_PERFERRED_CONTACT_LESS,
  UPDATE_SELECTED_CUSTOM_OPTIONS,
  EMPTY_SELECTED_CUSTOM_OPTIONS,
  MODIFY_ORDER_DETAILS,
  SET_INSUFFICIENT_HOUSE_CHARGE_BALANCE,
  SELECT_BILLING_ADDRESS,
  UPDATE_MODIFY_ORDER_ID,
  CANCEL_MODIFY_ORDER,
  CANCEL_MODIFY_ORDER_SUCCESS,
  CANCEL_MODIFY_ORDER_FAILURE,
  UPDATE_CURBSIDE_PICKUP,
  SCROLL_TO_SHOW_NEW_AMOUNT,
  SET_IS_TAX_EXEMPT,
  SET_ALLOW_ADDITIONAL_CHARGE_APPLY_ON_ORDER,
  SET_IS_PRINTED_RECEIPT_WITH_ORDER,
  SET_CUSTOMER_DETAILS,
  RESET_CHECKOUT_STATE,
  SET_ACCEPTED_AGE_RESTRICTION,
  SET_SHOULD_CONFIRM_CATERING_MEAL_DELIVERY,
} from "redux/constants/actionTypes";

let initialState = {
  customerAddress: null,
  customerAddressLoading: false,
  customerAddressError: "",
  customerAddressList: [],
  customerAddressListLoading: false,
  customerAddressListError: "",
  checkoutStoreType: "",
  checkoutPaymentMethod: "",
  storeTimeSlots: null,
  storeTimeSlotsLoading: false,
  storeTimeSlotsError: "",
  cartAmountDetails: {},
  cartAmountDetailsLoading: false,
  cartAmountDetailsError: "",
  checkoutTimeSlot: "",
  checkoutTimeSlotName: "",
  savePlaceOrder: {},
  savePlaceOrderLoading: false,
  savePlaceOrderError: "",
  savePlaceOrderCateringAndMeal: {},
  savePlaceOrderCateringAndMealLoading: false,
  savePlaceOrderCateringAndMealError: "",
  checkoutInstruction: "",
  checkoutContactType: "call_me",
  checkoutContactTypeLabel: "Call me",
  checkoutContact: "",

  removeAddressLoading: true,
  removeAddressError: false,
  removeAddressStatus: '',

  checkoutPickupType: 'later',
  ebtPaymentResponse: null,
  isFollowedEbtPayment: false,
  ebtPaymentPaidList: [],

  cancelPaidEbtEntryLoading: false,

  fetOrderDetailLoading: false,
  orderDetail: null,
  fetOrderDetailError: "",

  paymentTransactionId: "",
  paymentTransactionType: "",
  externalDeliveryId: "",

  cateringAndMealkitCartAmountDetails: {},
  cateringAndMealkitCartAmountDetailsLoading: false,
  cateringAndMealkitCartAmountDetailsError: "",

  doorDashContactLessDropDownOption: "",
  selectedCustomOptions: [],

  insufficientHouseChargeBalance: false,
  modifyOrderId: "",

  cancellingModifyOrder: false,
  cancellingModifyOrderError: "",

  isCurbSidePickup: false,
  curbSideComment: "",

  scrollToShowNewAmount: false,
  isTaxExempt: false,
  allowAdditionalChargeApplyOnOrder: true,
  customers: [],

  deliveryLockerType: null,
  billingAddress: "",
  isPrintedReceiptWithOrder: false,
  ageRestrictionAccepted: false,

  shouldConfirmCateringMealDelivery: undefined
};

const applyCheckoutShippingFields = (target, source) => {
  if (!source) return;
  const {
    shipping_method,
    is_apply_tax_exemption_on_this_order,
    shipping_address_id,
  } = source;

  if (shipping_method) {
    target.checkoutStoreType = shipping_method;
  }
  
  if (is_apply_tax_exemption_on_this_order) {
    target.isTaxExempt = is_apply_tax_exemption_on_this_order === "1";
  }
  
  if (shipping_address_id) {
    target.customerAddress = shipping_address_id;
  }
};

const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    // add customer address
    case ADD_CUSTOMER_ADDRESS:
      return {
        ...state,
        customerAddressLoading: true,
      };
    case ADD_CUSTOMER_ADDRESS_SUCCESS:

      const updatedAddressList = state.customerAddressList.map((address) => {
        return {
          ...address,
          is_primary: "0",
        };
      })
      return {
        ...state,
        customerAddressLoading: false,
        customerAddressList: [...updatedAddressList, action.payload]
      };
    case ADD_CUSTOMER_ADDRESS_FAILURE:
      return {
        ...state,
        customerAddressLoading: false,
        customerAddressError: action.payload.error,
      };

    // customer address list
    case FETCH_CUSTOMER_ADDRESS_LIST:

      return {
        ...state,
        customerAddressListLoading: true,
      };
    case FETCH_CUSTOMER_ADDRESS_LIST_SUCCESS:

      return {
        ...state,
        customerAddressListLoading: false,
        customerAddressList: action?.payload?.data ?? [],
        deliveryLockerType: +action?.payload?.delivery_locker_type,
      };
    case FETCH_CUSTOMER_ADDRESS_LIST_FAILURE:
      return {
        ...state,
        customerAddressListError: action.payload.error,
      };

    // Store time slots
    case FETCH_STORE_TIME_SLOTS:
      return {
        ...state,
        storeTimeSlotsLoading: true,
        storeTimeSlotsError: "",
      };
    case FETCH_STORE_TIME_SLOTS_SUCCESS:
      return {
        ...state,
        storeTimeSlotsLoading: false,
        storeTimeSlots: action.payload,
        storeTimeSlotsError: "",
      };
    case FETCH_STORE_TIME_SLOTS_FAILURE:
      return {
        ...state,
        storeTimeSlotsError: action.payload.error,
      };

    // Cart amount
    case FETCH_CART_AMOUNT_DETAILS:
      return {
        ...state,
        cartAmountDetailsLoading: true,
        cartAmountDetails: { ...state.cartAmountDetails, status: undefined, message: undefined },
      };
    case FETCH_CART_AMOUNT_DETAILS_SUCCESS: {
      const isErrorResponse = action.payload?.status === "error";
      const getAmount = data => Number(data?.price_list?.find(p => p?.key_name === "grand_total")?.amount ?? 0)
      const newAmount = getAmount(action?.payload?.data)
      const oldAmount = getAmount(state?.cartAmountDetails?.data)
      const amountChanged = newAmount !== oldAmount

      const updatedCartAmountDetails = isErrorResponse
        ? { ...state.cartAmountDetails, status: action.payload.status, message: action.payload.message }
        : action.payload;

      return {
        ...state,
        cartAmountDetailsLoading: false,
        cartAmountDetails: updatedCartAmountDetails,
        scrollToShowNewAmount: isErrorResponse ? false : amountChanged,
      };
    }
    case FETCH_CART_AMOUNT_DETAILS_FAILURE:
      return {
        ...state,
        cartAmountDetailsError: action.payload.error,
      };

    // Save order
    case SAVE_PLACE_ORDER: 
      return {
        ...state,
        savePlaceOrderLoading: true,
        savePlaceOrderError: '',
        checkoutInstruction: "",
        curbSideComment: "",
      };
    case SAVE_PLACE_ORDER_SUCCESS: {
      if (DEBUG) {
        debugger
      }

      const newState = {
        ...state,
        savePlaceOrderLoading: false,
        savePlaceOrder: action.payload,
      };
      applyCheckoutShippingFields(newState, action.payload);
      return newState;
    }

    case SAVE_PLACE_ORDER_FAILURE:
      return {
        ...state,
        savePlaceOrderLoading: false,
        savePlaceOrderError: action.payload.error,
      };

    // Save order catering and meals
    case SAVE_PLACE_ORDER_CATERING_MEAL:
      return {
        ...state,
        savePlaceOrderCateringAndMealLoading: true,
      };
    case SAVE_PLACE_ORDER_CATERING_MEAL_SUCCESS:
      return {
        ...state,
        savePlaceOrderCateringAndMealLoading: false,
        savePlaceOrder: action.payload,
      };
    case SAVE_PLACE_ORDER_CATERING_MEAL_FAILURE:
      return {
        ...state,
        savePlaceOrderCateringAndMealLoading: false,
        savePlaceOrderCateringAndMealError: action.payload.error,
      };

    case SELECT_CHECKOUT_STORE_TYPE:
      return {
        ...state,
        checkoutStoreType: action.payload,
      };
    case SELECT_PICKUP_TYPE:
      return {
        ...state,
        checkoutPickupType: action.payload,
      };

    case SELECT_CHECKOUT_PAYMENT_METHOD:
      return {
        ...state,
        checkoutPaymentMethod: action.payload,
      };
    case SELECT_CHECKOUT_TIME_SLOT:
      return {
        ...state,
        checkoutTimeSlot: action.payload?.value,
        checkoutTimeSlotName: action.payload?.title,
      };
    case SELECT_CUSTOMER_ADDRESS:
      return {
        ...state,
        customerAddress: action.payload,
      };
    case CHECKOUT_SPECIAL_INSTRUCTION:
      return {
        ...state,
        checkoutInstruction: action.payload,
      };
    case CHECKOUT_ORDER_PERFERRED_CONTACT_TYPE:
      return {
        ...state,
        checkoutContactType: action.payload.value,
        checkoutContactTypeLabel: action.payload.name,
      };
    case CHECKOUT_ORDER_PERFERRED_CONTACT:
      return {
        ...state,
        checkoutContact: action.payload + "",
      };

    //Adress Remove
    case REMOVE_CUSTOMER_ADDRESS:
      return {
        ...state,
        removeAddressLoading: true,
      };
    case REMOVE_CUSTOMER_ADDRESS_SUCCESS:
      return {
        ...state,
        removeAddressLoading: false,
        removeAddressStatus: action.payload.status,
      };
    case REMOVE_CUSTOMER_ADDRESS_FAILURE:
      return {
        ...state,
        removeAddressError: action.payload.error,
      };
    case SAVE_EBT_PAYMENT_RESPONSE:
      let isFollowedEbtPayment = action.payload ? true : false
      if (action.payload?.ebt_payment_status === 'failure') {
        isFollowedEbtPayment = false
      }
      return {
        ...state,
        ebtPaymentResponse: action.payload,
        isFollowedEbtPayment
      };
    case SAVE_EBT_PAYMENT_PAID_LIST:
      return {
        ...state,
        ebtPaymentPaidList: action.payload,
      };

    case CANCEL_EBT_PAYMENT:
      return {
        ...state,
        cancelPaidEbtEntryLoading: true,
      };
    case CANCEL_EBT_PAYMENT_SUCCESS:
      return {
        ...state,
        ebtPaymentPaidList: [],
        isFollowedEbtPayment: false,
        cancelPaidEbtEntryLoading: false,
      };

    case RESET_EBT_CHECKOUT_STATE:
      return {
        ...state,
        ebtPaymentPaidList: [],
        isFollowedEbtPayment: false,
        cancelPaidEbtEntryLoading: false,
        ebtPaymentResponse: null,
        checkoutInstruction: ""
      };

    case CANCEL_EBT_PAYMENT_FAILURE:
      return {
        ...state,
        cancelPaidEbtEntryLoading: false,
        cancelPaidEbtEntryError: action.payload.error,
      };

    case FETCH_ORDER_DETAIL:
      return {
        ...state,
        fetOrderDetailLoading: true,
      };

    case FETCH_ORDER_DETAIL_SUCCESS: {
      if (DEBUG) debugger
      const newState = {
        ...state,
        fetOrderDetailLoading: false,
        isFollowedEbtPayment: !!action.payload.paid_list.length,
        savePlaceOrder: action.payload.order_details,
        ebtPaymentPaidList: action.payload.paid_list,
        checkoutStoreType: action.payload.order_details.shipping_method,
      };
      applyCheckoutShippingFields(newState, action.payload.order_details);
      return newState;
    }
    
    case FETCH_ORDER_DETAIL_FAILURE:
      return {
        ...state,
        fetOrderDetailLoading: false,
        fetOrderDetailError: action.payload.error,
      };

    case SAVE_PAYMENT_TRANSACTION_ID:
      return {
        ...state,
        paymentTransactionId: action.payload
      };
    case SAVE_PAYMENT_TRANSACTION_TYPE:
      return {
        ...state,
        paymentTransactionType: action.payload
      };
    case EXTERNAL_DELIVERY_ID:
      return {
        ...state,
        externalDeliveryId: action.payload,
      };

    // Cart amount
    case FETCH_CATERING_AND_MEALKIT_CART_AMOUNT_DETAILS:
      return {
        ...state,
        cateringAndMealkitCartAmountDetailsLoading: true,
        cateringAndMealkitCartAmountDetails: { ...state.cateringAndMealkitCartAmountDetails, status: undefined, message: undefined },
      };
    case FETCH_CATERING_AND_MEALKIT_CART_AMOUNT_DETAILS_SUCCESS: {
      const isErrorResponse = action?.payload?.status === "error"
      const updatedCateringAndMealkitCartAmountDetails = isErrorResponse
        ? { ...state.cateringAndMealkitCartAmountDetails, status: action?.payload?.status, message: action?.payload?.message }
        : action.payload;
      return {
        ...state,
        cateringAndMealkitCartAmountDetailsLoading: false,
        cateringAndMealkitCartAmountDetails: updatedCateringAndMealkitCartAmountDetails,
      };
    }
    case FETCH_CATERING_AND_MEALKIT_CART_AMOUNT_DETAILS_FAILURE:
      return {
        ...state,
        cateringAndMealkitCartAmountDetailsError: action.payload.error,
      };
    case CHECKOUT_ORDER_DOORDASH_PERFERRED_CONTACT_LESS:
      return {
        ...state,
        doorDashContactLessDropDownOption: action.payload,
      };
    case UPDATE_SELECTED_CUSTOM_OPTIONS:
        return {
        ...state,
        selectedCustomOptions: action.payload,
        };
    case EMPTY_SELECTED_CUSTOM_OPTIONS:
          return {
            ...state,
            selectedCustomOptions: [],
          };
    case MODIFY_ORDER_DETAILS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_INSUFFICIENT_HOUSE_CHARGE_BALANCE:
      return {
        ...state,
        insufficientHouseChargeBalance: action.payload,
      };
    case UPDATE_MODIFY_ORDER_ID:
      return {
        ...state,
        modifyOrderId: action.payload
      };
    case CANCEL_MODIFY_ORDER:
      return {
        ...state,
        cancellingModifyOrder: true,
        cancellingModifyOrderError: "",
      };
    case CANCEL_MODIFY_ORDER_SUCCESS:
      return {
        ...state,
        cancellingModifyOrder: false,
        checkoutInstruction: "",
        curbSideComment: "",
      };
    case CANCEL_MODIFY_ORDER_FAILURE:
      return {
        ...state,
        cancellingModifyOrder: false,
        cancellingModifyOrderError: action.payload.error,
        isCurbSidePickup: false,
      };
    case UPDATE_CURBSIDE_PICKUP:
      const data = {}
      if ("isCurbSidePickup" in action.payload) {
        data.isCurbSidePickup = action.payload.isCurbSidePickup
        if (state.savePlaceOrderError === CURBSIDE_PICKUP_REQUIRED) {
          data.savePlaceOrderError = ""
        }
      }
      if ("curbSideComment" in action.payload) {
        data.curbSideComment = action.payload.curbSideComment
      }
      return {
        ...state,
        ...data,
      };
    case SCROLL_TO_SHOW_NEW_AMOUNT:
      return {
        ...state,
        scrollToShowNewAmount: action.payload,
      };
    case SET_IS_TAX_EXEMPT:
      return {
        ...state,
        isTaxExempt: action.payload,
      };
    case SET_ALLOW_ADDITIONAL_CHARGE_APPLY_ON_ORDER:
      return {
        ...state,
        allowAdditionalChargeApplyOnOrder: action.payload,
      };
    case SET_IS_PRINTED_RECEIPT_WITH_ORDER:
      return {
        ...state,
        isPrintedReceiptWithOrder: action.payload,
      };
    case SET_CUSTOMER_DETAILS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case RESET_CHECKOUT_STATE:
      return {
        ...state,
        isTaxExempt: false,
        curbSideComment: "",
        isPrintedReceiptWithOrder: false,
        ageRestrictionAccepted: false,
        allowAdditionalChargeApplyOnOrder: true,
      };
    case SELECT_BILLING_ADDRESS:
      return {
        ...state,
        billingAddress: action.payload,
      };
    case SET_ACCEPTED_AGE_RESTRICTION:
      return {
        ...state,
        ageRestrictionAccepted: action.payload,
      };
    case SET_SHOULD_CONFIRM_CATERING_MEAL_DELIVERY:
      return {
        ...state,
        shouldConfirmCateringMealDelivery: action.payload,
      };
    default:
      return state;
  }
};

export default checkoutReducer;